<template>
  <div class="css-title-link">
    <div v-if="titleText" class="title">
      <div class="text">
        {{ titleText }}
      </div>
      <a :href="titleLink" class="link" target="_blank" rel="noopener noreferrer" @click="linkOnClick">
        {{ $t('CSS.MORE') }}
        <i class="material-icons">
          chevron_right
        </i>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CSSTitleLink',
  components: {},
  directives: {},
  props: {
    titleText: {
      type: String,
      default: ''
    },
    titleLink: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    linkOnClick() {
      // console.log(`CSS title link on click.`)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.css-title-link {
  // position: relative;
  .title {
    margin: 16px 0;
    font-size: 24px;
    font-weight: 500;
    line-height: 39px;
    letter-spacing: normal;
    color: $grey-50;
    .text {
      display: inline-block;
      // vertical-align: middle;
    }
    .link {
      float: right;
      display: inline-block;
      vertical-align: top;
      font-size: 20px;
      font-weight: normal;
      line-height: 39px;
      text-decoration: none;
      transition: color .4s ease;
      cursor: pointer;
      > i {
        display: inline-block;
        vertical-align: top;
        line-height: 39px;
        font-size: 24px;
      }
      @include default-link-hover($grey-50)
    }
  }
}
@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {}
</style>
